import { gql } from '@apollo/client';

const FEE_WAIVER_HISTORY = gql`
  query FeeWaiverHistory($accountId: String!, $customerId: String!) {
    account(accountId: $accountId, customerId: $customerId) {
      id
      checkEligibility(eligibilityType: FEE_WAIVER) {
        eligibility {
          eligible
          reasons {
            code
            description
            pass
          }
          waiverNotes {
            createdAt
            note
          }
          waiverTransactions {
            amount
            date
            description
          }
        }
      }
    }
  }
`;

const FEE_WAIVER_ELIGIBILITY = gql`
  query FeeWaiverEligibility(
    $accountId: String!
    $postedDate: String!
    $transactionId: String!
  ) {
    adjustmentEligibility(
      accountId: $accountId
      customerAdjustmentInput: {
        postedDate: $postedDate
        transactionId: $transactionId
      }
    ) {
      eligible
    }
  }
`;

export { FEE_WAIVER_ELIGIBILITY, FEE_WAIVER_HISTORY };
